import {
  createPlugin,
  createComponentExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const environmentVariablesPlugin = createPlugin({
  id: 'environment-variables',
  routes: {
    root: rootRouteRef,
  },
});

export const EnvironmentVariablesComponent = environmentVariablesPlugin.provide(
  createComponentExtension({
    name: 'EnvironmentVariablesComponent',
    component: {
      lazy: () =>
        import('./components/EnvironmentVariablesComponent').then(
          m => m.EnvironmentVariablesComponent,
        ),
    },
  }),
);
